import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { FormResponse } from 'src/models/form-response';
import { map } from 'rxjs/operators';
import { Stream } from 'src/models/stream';
import { HttpClient } from '@angular/common/http';
import { AccountService } from './account.service';
import { User } from 'src/models/user';
import { Episode } from 'src/models/episode';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private apiURL = '/restricted/user';

  private favorites = new BehaviorSubject<Array<Stream>>(new Array());

  constructor(
    private accountService: AccountService,
    private httpClient: HttpClient) {
      accountService.loggedInUser.subscribe((user: User) => {
        if (user !== undefined) {
          this.loadFavorites().subscribe();
        }
      });
  }

  private loadFavorites(): Observable<Stream[]> {
    return this.httpClient.get<Stream[]>(this.apiURL + '/favorites').pipe(map(res => {
      const result = new Array<Stream>();

      const resStreams: Array<object> = res['params']['streams'];

      resStreams.forEach((item: object) => {
          result.push(Stream.fromResponseData(item));
      });

      this.favorites.next(result);

      return result;
    }));
  }

  public getFavorites(): BehaviorSubject<Array<Stream>>  {
    return this.favorites;
  }

  public addToFavorites(stream: Stream): Observable<FormResponse> {

    const endpoint = isNaN(stream.id) ? 'addPodcastToFavorites' : 'addToFavorites';

    const streamId = stream instanceof Episode ? stream.podcast.id : stream.id;

    return this.httpClient.post<object>(this.apiURL + '/' + endpoint, {
      streamId
    }).pipe(map(res => {
      const formResponse = new FormResponse(res);

      if (formResponse.result === true) {
        this.loadFavorites().subscribe();
      }

      return formResponse;
    }));
  }

  public removeFromFavorites(stream: Stream): Observable<FormResponse> {

    const endpoint = isNaN(stream.id) ? 'removePodcastFromFavorites' : 'removeFromFavorites';

    const streamId = stream instanceof Episode ? stream.podcast.id : stream.id;

    return this.httpClient.post<object>(this.apiURL + '/' + endpoint, {
      streamId
    }).pipe(map(res => {
      const formResponse = new FormResponse(res);

      this.loadFavorites().subscribe();

      return formResponse;
    }));
  }
}
